import React from 'react';
import { Col, Row } from '@gjensidige/core-grid';
import { Text } from '@gjensidige/core-typography';
import { useCmsContext } from '@gjensidige/service-cms';

import checklist from '../../resources/images/check-list.svg';
import cup from '../../resources/images/cup.svg';
import TextContainer from '../TextContainer';
import styles from './WayForward.module.scss';

const WayForward = () => {
  const { getText } = useCmsContext();

  return (
    <TextContainer className={styles.bottomContent}>
      <Row className={styles.bottomContentRow}>
        <Col xs={12} className={styles.imageWrapper}>
          <img src={cup} alt="cup" className={styles.imageCup} />
          <img src={checklist} alt="checklist" className={styles.image} />
        </Col>
        <Col xs={12} md={6} className={styles.shareLinks}>
          <a
            href="https://www.gjensidige.no/godtforberedt/"
            className={styles.link}
            rel="noreferrer"
            target="_blank"
          >
            {getText('housing.check.summary.wayForward.link1')}
          </a>
          <Text>{getText('housing.check.summary.wayForward.link2')}</Text>
        </Col>
      </Row>
    </TextContainer>
  );
};

export default WayForward;
